var App = App || {};

App.PromotionsBand = (function ($) {
    'use strict';

    function init() {
        const component = $(".promotions-band");

        component.each(function () {
            const carousel = component.find(".splide");
            setCarousel(carousel);
        });
    }

    function setCarousel(carousel) {

        const splide = new Splide(carousel[0], {
            mediaQuery: 'min',
            arrows: true,
            pagination: false,
            perMove: 1,
            perPage: 3,
            focus: 0,
            gap:"20px",
            type: 'loop',
            width: "100%",
            breakpoints: {
                992: {
                    arrows: false,
                    focus: 0,
                    perPage: 3,
                    perMove: 1,
                    width: "850px",
                    gap: "20px",
                }
            }
        });

        splide.on('mounted resize', function () {
            nudgeSlides(splide, splide.index);
        });

        splide.on('move', function (newIndex) {
            nudgeSlides(splide, newIndex);
        });

        splide.mount();
    }

    function nudgeSlides(splide, index) {
        splide.Components.Slides.get().forEach(slide => { $(slide.slide).removeClass('nudge-1 nudge-2'); });

        const Bp = ZAGFramework.GetCurrentBP();
        $(splide.Components.Slides.getAt(index).slide).addClass('nudge-1');
        $(splide.Components.Slides.getAt(index + 1).slide).addClass('nudge-2');
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PromotionsBand.init();
});